import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Donation } from "../../../../store/state";
import { API_URL } from "../../../../config/api";
import { draftAvtaleGiroAction } from "../../../../store/donation/actions";
import { SubmitButton } from "../../../shared/Buttons/NavigationButtons";
import { usePlausible } from "next-plausible";
import { Dispatch } from "@reduxjs/toolkit";
import { Action } from "typescript-fsa";
import { calculateDonationBreakdown } from "../../../../utils/donationCalculations";
export const RecurringBankDonationForm: React.FC<{
  donation: Donation;
  buttonText: string;
}> = t0 => {
  const $ = _c(49);
  const {
    donation,
    buttonText
  } = t0;
  const dispatch = useDispatch();
  const plausible = usePlausible();
  const causeAreas = useSelector(_temp) || [];
  let t1;
  if ($[0] !== donation.causeAreaAmounts) {
    t1 = donation.causeAreaAmounts ?? {};
    $[0] = donation.causeAreaAmounts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== donation.orgAmounts) {
    t2 = donation.orgAmounts ?? {};
    $[2] = donation.orgAmounts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== donation.causeAreaDistributionType) {
    t3 = donation.causeAreaDistributionType ?? {};
    $[4] = donation.causeAreaDistributionType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== donation.operationsPercentageModeByCauseArea) {
    t4 = donation.operationsPercentageModeByCauseArea ?? {};
    $[6] = donation.operationsPercentageModeByCauseArea;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== donation.operationsPercentageByCauseArea) {
    t5 = donation.operationsPercentageByCauseArea ?? {};
    $[8] = donation.operationsPercentageByCauseArea;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = donation.selectionType ?? "single";
  const t7 = donation.selectedCauseAreaId ?? 1;
  const t8 = donation.globalOperationsEnabled ?? false;
  const t9 = donation.globalOperationsPercentage ?? 0;
  let t10;
  if ($[10] !== donation.operationsConfig?.excludedCauseAreaIds) {
    t10 = donation.operationsConfig?.excludedCauseAreaIds ?? [];
    $[10] = donation.operationsConfig?.excludedCauseAreaIds;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = donation.operationsConfig?.operationsCauseAreaId;
  let t12;
  if ($[12] !== causeAreas || $[13] !== donation.smartDistributionTotal || $[14] !== t1 || $[15] !== t10 || $[16] !== t11 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t12 = calculateDonationBreakdown(t1, t2, t3, t4, t5, causeAreas, t6, t7, t8, t9, t10, t11, donation.smartDistributionTotal);
    $[12] = causeAreas;
    $[13] = donation.smartDistributionTotal;
    $[14] = t1;
    $[15] = t10;
    $[16] = t11;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const breakdown = t12;
  const totalSumIncludingTip = breakdown.totalAmount;
  let t13;
  if ($[26] !== dispatch || $[27] !== plausible) {
    t13 = e => {
      plausible("DraftAvtalegiro");
      e.preventDefault();
      dispatch(draftAvtaleGiroAction.started(undefined));
    };
    $[26] = dispatch;
    $[27] = plausible;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const onSubmit = t13;
  let t14;
  let t15;
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      paddingBottom: 30,
      display: "flex",
      justifyContent: "center"
    };
    t15 = <input type="hidden" name="companyName" id="companyName" value="Effektiv Altruisme Norge" />;
    t16 = <input type="hidden" name="companyAccountNo" id="companyAccountNo" value="15062995960" />;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t14 = $[29];
    t15 = $[30];
    t16 = $[31];
  }
  let t17;
  if ($[32] !== donation.kid) {
    t17 = <input type="hidden" name="kid" id="kid" value={donation.kid} />;
    $[32] = donation.kid;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const t18 = totalSumIncludingTip && totalSumIncludingTip > 20000 ? totalSumIncludingTip : 20000;
  let t19;
  if ($[34] !== t18) {
    t19 = <input type="hidden" name="amountLimit" id="amountLimit" value={t18} />;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const t20 = `${API_URL}/avtalegiro/${donation.kid}/redirect`;
  let t21;
  if ($[36] !== t20) {
    t21 = <input type="hidden" name="returnUrl" id="returnUrl" value={t20} />;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <input type="hidden" name="notificationDisabled" id="notificationDisabled" value="false" />;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== onSubmit) {
    t23 = e_0 => onSubmit(e_0);
    $[39] = onSubmit;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== buttonText || $[42] !== t23) {
    t24 = <SubmitButton onClick={t23}>{buttonText}</SubmitButton>;
    $[41] = buttonText;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t17 || $[45] !== t19 || $[46] !== t21 || $[47] !== t24) {
    t25 = <div><form data-cy="avtalegiro-form" id="avtalegiro-form" action="https://pvu.avtalegiro.no/ecsa/start" method="post" target="_parent" style={t14}>{t15}{t16}{t17}{t19}{t21}{t22}{t24}</form></div>;
    $[44] = t17;
    $[45] = t19;
    $[46] = t21;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  return t25;
};
function _temp(state) {
  return state.layout.causeAreas;
}